var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentskaSluzba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69225 14.3077H15.3077V14.1423C15.3077 13.5589 15.0148 13.1073 14.4288 12.7875C13.8429 12.4677 13.0333 12.3077 12 12.3077C10.9667 12.3077 10.1571 12.4677 9.57125 12.7875C8.98525 13.1073 8.69225 13.5589 8.69225 14.1423V14.3077ZM12 10.6923C12.4218 10.6923 12.7773 10.5477 13.0663 10.2587C13.3554 9.96958 13.5 9.61408 13.5 9.19225C13.5 8.77042 13.3554 8.415 13.0663 8.126C12.7773 7.83683 12.4218 7.69225 12 7.69225C11.5782 7.69225 11.2228 7.83683 10.9338 8.126C10.6446 8.415 10.5 8.77042 10.5 9.19225C10.5 9.61408 10.6446 9.96958 10.9338 10.2587C11.2228 10.5477 11.5782 10.6923 12 10.6923ZM9 20V18H4.6155C4.15517 18 3.77083 17.8458 3.4625 17.5375C3.15417 17.2292 3 16.8448 3 16.3845V5.6155C3 5.15517 3.15417 4.77083 3.4625 4.4625C3.77083 4.15417 4.15517 4 4.6155 4H19.3845C19.8448 4 20.2292 4.15417 20.5375 4.4625C20.8458 4.77083 21 5.15517 21 5.6155V16.3845C21 16.8448 20.8458 17.2292 20.5375 17.5375C20.2292 17.8458 19.8448 18 19.3845 18H15V20H9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentskaSluzba);
export default __webpack_public_path__ + "static/media/studentska-sluzba.84515c06224f1dd190ce8fa2998b0c86.svg";
export { ForwardRef as ReactComponent };